import type { Supabase } from '~/types/supabase-client';
import TableService from './table.service';

export class ConferencesService extends TableService<'conferences'> {
  constructor(supabase: Supabase) {
    super(supabase, 'conferences', {
      pk: 'id',
      defaultSort: { field: 'name', ascending: false, nullsFirst: true },
    });
  }
}
